module.exports = __webpack_public_path__ + "static/primer-dropdown-1f21a8d9962835110e4c84c3846fef32.png";